import React, { memo } from "react";

import { useBottomMenu } from "../../hooks/useBottomMenu";
import { useIsPreviewMode } from "../../hooks/useIsPreviewMode";

import { CommandHistory } from "../command-history";
import { FloatingMenu } from "../floating-menu";
import { PreviewButton } from "../preview-button";

import { useDashboardContext } from "../../contexts/dashboard-context";
import { useDefinition } from "../../hooks/useDefinition";
import { useIsTransformMode } from "../../hooks/useIsTransformMode";
import { CloneButton } from "../clone-button";
import { EventsButton } from "../events-button";
import { TopToolbar } from "./top-toolbar";
import { SpreadOverviewButton } from "../spread-overview/spread-overview-button";
import { BottomMenuPaths } from "../bottom-menu/paths";

function RightTopToolBar() {
	const dashboard = useDashboardContext();
	const definition = useDefinition();
	const enableCopySpreads = definition?.product?.copySpreads;
	const enableCalendarEvents = dashboard.canChangeCalendarEvents();
	const enableSpreadOverview = definition?.canManipulateSpreads();

	return (
		<>
			{enableCalendarEvents && <EventsButton />}
			{enableCopySpreads && <CloneButton />}
			{enableSpreadOverview && <SpreadOverviewButton />}
			<PreviewButton />
			<FloatingMenu />
		</>
	);
}

export const TopToolbarContainer = memo(function TopToolbarContainer() {
	const { currentPath } = useBottomMenu();
	const isEditingText = currentPath === BottomMenuPaths.TextValue;
	const isInQREditMode = currentPath === BottomMenuPaths.QrEdit;
	const isInQRAddMode = currentPath === BottomMenuPaths.QrAdd;

	const [isTransformMode] = useIsTransformMode();
	const [isPreviewMode] = useIsPreviewMode();

	// Don't show top toolbar in previewMode or when editing text (save some space on small devices)
	if (isPreviewMode || isEditingText || isInQREditMode || isInQRAddMode) return null;

	// Empty topbar is rendered as to avoid product "jumping"
	if (isTransformMode) {
		return <TopToolbar left={null} right={null} />;
	}

	return <TopToolbar left={<CommandHistory />} right={<RightTopToolBar />} />;
});
